export default {
  methods: {
    gtmViewItem(vip) {
      this.pushDataLayer({ ecommerce: null });
      this.pushDataLayer({
        event: 'view_item',
        ecommerce: {
          currency: 'EUR',
          value: vip.content.price / 100,
          items: [
            {
              item_id: vip.id,
              item_name: vip.content.display_name,
              index: 0,
              ...this.getCategoriesForVip(vip),
              price: vip.content.price / 100,
              quantity: 1,
            }],
        },
      });
    },

    gtmAddToCart(vip) {
      this.pushDataLayer({ ecommerce: null });
      this.pushDataLayer({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'EUR',
          value: vip.content.price / 100,
          items: [
            {
              item_id: vip.id,
              item_name: vip.content.display_name,
              index: 0,
              ...this.getCategoriesForVip(vip),
              price: vip.content.price / 100,
              quantity: 1,
            }],
        },
      });
    },

    gtmBeginCheckout(vip) {
      this.pushDataLayer({ ecommerce: null });
      this.pushDataLayer({
        event: 'begin_checkout',
        ecommerce: {
          currency: 'EUR',
          value: vip.content.price / 100,
          items: [
            {
              item_id: vip.id,
              item_name: vip.content.display_name,
              index: 0,
              ...this.getCategoriesForVip(vip),
              price: vip.content.price / 100,
              quantity: 1,
            }],
        },
      });
    },

    gtmPurchase(payment, vip, shoutOut) {
      this.pushDataLayer({ ecommerce: null });
      this.pushDataLayer({
        event: 'purchase',
        ecommerce: {
          transaction_id: shoutOut.id,
          value: payment.value / 100,
          tax: 0,
          shipping: 0,
          currency: 'EUR',
          items: [
            {
              item_id: vip.id,
              item_name: vip.content.display_name,
              index: 0,
              ...this.getCategoriesForVip(vip),
              price: payment.value / 100,
              quantity: 1,
            }],
        },
      });
    },

    getCategoriesForVip (vip) {
      let categories = {};
      for (let key in vip.content.categories) {
        categories['item_category' + (key > 0 ? key : '')] = vip.content.categories[key].name;
      }

      return categories;
    },
  },
};

